import { defineComponent } from 'vue';
import CategoryTwelveComponent from '@/components/CategoryTwelve/CategoryTwelveComponent.vue';
export default defineComponent({
    name: 'CategoryTwelveDuplicateDialog',
    props: {
        propSelected: Array,
        propId: String
    },
    components: { CategoryTwelveComponent },
    data: function () {
        return {
            show: false,
            id: this.propId
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
